// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a0c43f1d","488":"9c92ff38"}[chunkId] + ".chunk.js";
};